/**
 * ordinal.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: "ordinal"})
export class OrdinalPipe implements PipeTransform {

  public transform (
    value : number,
    locale : string = "en"
  ) : string
  {
    if (!Number.isInteger(value))
    {
      throw new Error(`Ordinalization only works on integers! ${value} given.`);
    }
    if (locale.toLowerCase() === "en")
    {
      return this.ordinalizeEnglish(value);
    }
    throw new Error(`Non-English locales not yet supported for ordinalize!`);
  }

  public ordinalizeEnglish (i : number) : string
  {
    const isTeen : boolean = ((i % 100) > 10) && ((i % 100) < 20);
    if (!isTeen)
    {
      const ones : number = i % 10;
      if (ones === 1)
      {
        return `${i}st`;
      }
      if (ones === 2)
      {
        return `${i}nd`;
      }
      if (ones === 3)
      {
        return `${i}rd`;
      }
    }
    return `${i}th`;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/ordinal.pipe.ts